
"use strict";
var util = require('node-tools/js/util')
  , collections = require('./collections')
  , each = collections.each
  , every = collections.every
  , isArray = util.isArray
  , isString = util.isString
  , isObject = util.isObject

var propertyNameRegexp = /^[a-z][a-zA-Z0-9]*$/;

/**
 * Convert deep query to JSON string
 *
 * @param {Object} query - deep query
 * @param {boolean} pretty
 * @return {string}
**/
exports.serialize = function serialize(query, pretty) {
  if (!isObject(query)) {
    throw new TypeError("deep query must be an object");
  }
  return JSON.stringify(query, serializerFitler, pretty ? 2 : 0);
};

/**
 * Convert JSON string to deep query
 *
 * @param {string} json string
 * @return {Object}
**/
exports.deserialize = function deserialize(json) {
  var query = JSON.parse(json);
  if (!isObject(query)) {
    throw new TypeError("deep query must be a JSON object");
  }
  var metrics = query.metrics || query.select || [];
  if (!isArrayOfObjects(metrics)) {
    metrics = [];
  }
  var splits = query.splits || query.groupBy || [];
  if (!isArrayOfObjects(splits)) {
    splits = [];
  }
  var filters = query.filters || query.where || null;
  if ('object' !== typeof filters) {
    filters = null;
  }
  var conditions = query.conditions || query.having || null;
  if ('object' !== typeof conditions) {
    conditions = null;
  }
  var meta = query.meta || null;
  if ('object' !== typeof meta) {
    meta = null;
  }
  var order = query.order || query.orderBy || [];
  if (!isArrayOfObjects(order)) {
    order = [];
  }
  convertColumnToMetric(metrics); // LEGACY
  checkIntervals(query);
  checkGranularity(query);
  checkTimezone(query);
  checkTopAndOffset(query);
  var result = {
    metrics: metrics,
    splits: extractGroups(metrics, splits), // LEGACY
    filters: filters,
    conditions: conditions,
    top: query.top || null,
    intervals: query.intervals || null,
    granularity: query.granularity || "all",
    order: order
  };
  if (meta !== null) result.meta = meta;
  if (query.offset !== void 0) result.offset = query.offset;
  if (query.timeZone !== void 0) result.timeZone = query.timeZone;
  else if (query.timeZoneOffset !== void 0) result.timeZoneOffset = query.timeZoneOffset;
  if ('string' === typeof query.from && query.from) {
    result.from = query.from;
  }
  return result;
};

/**
 * Convert JSON string to deep query (old query builder)
 *
 * @param {string} json string
 * @return {Object}
 */
exports.deserializeLegacy = function deserializeLegacy(json) {
  var query = JSON.parse(json);
  var metrics = query.metrics || query.select;
  var splits = query.splits || query.groupBy;
  var filters = query.filters || query.where;
  delete query.metrics;
  delete query.splits;
  delete query.filters;
  delete query.having;
  delete query.conditions;
  query.select = metrics;
  query.groupBy = extractGroups(metrics, splits); // LEGACY
  query.where = filters;
  convertMetricToColumn(metrics);
  chain(metrics, null);
  chain(filters, null);
  attachColumnReferences(metrics, null);
  checkIntervals(query);
  checkGranularity(query);
  checkTimezone(query);
  checkTopAndOffset(query);
  return query;
};

function serializerFitler(key, value) {
  if (key === '' || 'number' === typeof this.length) {
    return value;
  }

  switch(key) {
    case 'granularity':
      if (value == null) {
          return '';
      }
      return typeof value === 'object' ? value : String(value);
    case 'regex':
    case 'name':
    case 'type':
    case 'from':
    case 'field':
    case 'timeZone':
    case 'metric':
      return value == null ? '' : String(value);
    case 'ref':
      return value ? value.name : null;
    case 'timeZoneOffset':
    case 'top':
    case 'offset':
      if (value == null) return null;
      value = parseInt(value);
      return isNaN(value) ? 0 : value;
    case 'negative':
      return !!value;
    default:
      if (propertyNameRegexp.test(key)) {
        return value;
      }
  }

  return void 0;
}

function checkIntervals(query) {
  if ('intervals' in query) {
    var intervals = query.intervals;
    if ('string' !== typeof intervals &&
       (intervals === null || !isArray(intervals) || !every(intervals, isString))) {
      delete query.intervals;
    }
  }
}

function checkGranularity(query) {
  if ('granularity' in query) {
    var granularity = query.granularity;
    if (('string' !== typeof granularity && 'number' !== typeof granularity) || !granularity) {
      delete query.granularity;
    }
  }
}

function checkTimezone(query) {
  if ('timeZone' in query) {
    var timeZone = query.timeZone;
    if ('string' !== typeof timeZone || !timeZone)
      delete query.timeZone;
  }
  if ('timeZoneOffset' in query) {
    var timeZoneOffset = query.timeZoneOffset;
    if ('number' !== typeof timeZoneOffset || !isFinite(timeZoneOffset))
      delete query.timeZoneOffset;
  }
}

function checkTopAndOffset(query) {
  var value = parseInt(query.top);
  if (isFinite(value)) {
    query.top = value;
  } else {
    delete query.top;
  }

  value = parseInt(query.offset);
  if (isFinite(value)) {
    query.offset = value;
  } else {
    delete query.offset;
  }
}

function isArrayOfObjects(array) {
  return isArray(array) && every(array, function(item) {
    return !isArray(item) && isObject(item);
  });
}

function extractGroups(select, groupBy) {
  groupBy || (groupBy = []);
  for(var i = select.length; i-- > 0; ) {
    var column = select[i];
    if (column && column.type === "group") {
      select.splice(i, 1);
      groupBy.push({
        name:  column.name || "",
        field: column.field || "",
        regex: column.regex || ""
      });
    }
  }
  return groupBy;
}

function convertColumnToMetric(columns) {
  each(columns, function(col) {
    if (col.type === 'column') {
      col.type = 'metric';
      col.metric = col.ref || "";
    } else if (col.args)
      convertColumnToMetric(col.args);
  });
}

function convertMetricToColumn(columns) {
  each(columns, function(col) {
    if (col.type === 'metric') {
      col.type = 'column';
      col.ref = col.metric || "";
    } else if (col.args)
      convertMetricToColumn(col.args);
  });
}

function attachColumnReferences(columns, names) {
  if (names) {
    each(columns, function(col) {
      if (col.type === 'column') {
        var refcol = names[col.ref];
        col.ref = refcol || null;
      } else if (col.args)
        attachColumnReferences(col.args, names);
    });
  } else {
    names = {};
    each(columns, function(col) { names[col.name] = col });
    each(columns, function(col) { if (col.args) attachColumnReferences(col.args, names) });
  }
}

function chain(object, parent) {
  var children;
  if (object && 'number' === typeof object.length) {
    children = object;
    object = null;
  } else if (object) {
    object.parent = parent;
    if (object.children) {
      children = object.children;
    } else if (object.args) {
      children = object.args;
    } else if (object.filter) {
      chain(object.filter, null);
    }
  }
  if (children) {
    for(var i = children.length; i-- > 0; )
      chain(children[i], object);
  }
}
